module.exports = __webpack_public_path__ + "static/img/10019 (4).006cf3e.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10019 (4).webp
// module id = w7DH
// module chunks = 14